var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ContextMenuView',_vm._b({},'ContextMenuView',{ x: _vm.x, y: _vm.y },false),_vm._l((_vm.definitions),function(definition){return _c('ContextMenuItemView',{key:definition.id,on:{"click":function($event){return _vm.chooseDefinition(definition)}}},[_vm._v("\n        "+_vm._s(definition.name)+"\n    ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }